import Airports from ".";

export const airportRoutes = [
  {
    path: "/airports",
    element: <Airports />,
  },
];
